import { Box, Typography } from "@material-ui/core";
import { NoComments } from "Assets/index";
import { useStyles } from "./styles";

const NoCommentAdded = () => {
  const classes = useStyles();
  return (
    <Box className={classes.noComment} width="100%" textAlign="center">
      <NoComments />
      <Typography variant="body2" className={`font-12`}>
        No comments added
      </Typography>
    </Box>
  );
};

export default NoCommentAdded;
